import {Component, computed, inject} from '@angular/core';
import {NgStyle} from '@angular/common';
import {RISK_COLOR} from '@/app/utils/risk-colors';
import {ThemeService} from '@/app/core/services/theme/theme.service';

// Este mapeo conecta las llaves de los colores (risk-colors.ts) con las llaves del texto (theme.interface.ts).
const riskLevelMapping = [
  {colorKey: 'Muy alto', themeKey: 'veryHighRisk'},
  {colorKey: 'Alto', themeKey: 'highRisk'},
  {colorKey: 'Medio', themeKey: 'mediumRisk'},
  {colorKey: 'Bajo', themeKey: 'lowRisk'},
  {colorKey: 'Muy bajo', themeKey: 'veryLowRisk'},
] as const;

@Component({
  selector: 'app-legend-nivel',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './legend-nivel.html',
  styleUrls: ['./legend-nivel.scss'],
})
export class LegendNivelComponent {

  private themeService = inject(ThemeService);
  private themeContent = this.themeService.themeContent;

  protected legendContent = computed(() => this.themeContent()?.reports?.legendLevelComponent);

  // Señal que construye dinámicamente la leyenda.
  public riskLevels = computed(() => {
    const content = this.legendContent();
    // Si el contenido del tema aún no ha cargado, devuelve un array vacío para evitar errores.
    if (!content) return [];

    // Usa el mapeo para construir la lista de niveles, combinando el texto dinámico y el color correspondiente.
    return riskLevelMapping.map(mapping => ({
      name: content[mapping.themeKey],
      color: RISK_COLOR[mapping.colorKey],
    }));
  });
}
